import type { RouteObject } from 'react-router';

export const LAUNCH_DARKLY_PAGE_NAMES = {
	appointmentBasedSummary: 'Appointment-Based Summary',
	// For `/patient/<NID>/<TAB-PATH>` structure
	patientBasedSummary: 'Patient-Based Summary',
	// For `<TAB-PATH>/patient/<NID>/appointment/<SID>` structure
	patientBasedSummaryWithAppointment: 'Patient-Based Summary With Appointment',
	schedulingOverview: 'Scheduling Overview',
	patientLookup: 'Patient Lookup',
	analyticsDashboard: 'Analytics Dashboard',
	adminTool: 'Admin Tool',
	fileManager: 'File Manager',
	documentViewer: 'Document Viewer',
} as const satisfies Record<string, string>;

type LaunchDarklyPageName = (typeof LAUNCH_DARKLY_PAGE_NAMES)[keyof typeof LAUNCH_DARKLY_PAGE_NAMES];

export function withLaunchDarklyPage(pageName: LaunchDarklyPageName): Pick<RouteObject, 'handle'> {
	return {
		handle: {
			page: pageName,
		},
	};
}
